export var DocsBlockMode;
(function (DocsBlockMode) {
    /** Block has static items, and only one of it */
    DocsBlockMode[DocsBlockMode["singleItem"] = 0] = "singleItem";
    /** Block has static items, and multiple of them */
    DocsBlockMode[DocsBlockMode["multipleItems"] = 1] = "multipleItems";
    /** Block has dynamic data drawn from Supernovva */
    DocsBlockMode[DocsBlockMode["data"] = 2] = "data";
})(DocsBlockMode || (DocsBlockMode = {}));
